import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'saldoText',
})
export class SaldoTextPipe implements PipeTransform {
  transform(saldo: number): string {
    return saldo < 0 ? 'text-danger' : 'text-success';
  }
}
